module.exports = __webpack_public_path__ + "img/munster-rugby-logo-icon.b53dc435.png";